export interface LibModuleOptions {
  apiUrl: string;
  map: {
    geometryService: string;
    arcgisUrl: string;
    center: Array<number>;
    scale: number;
    maPhuongXa: string;
    maQuanHuyen: string;
    phuongXaUrl: string;
    bienDong:any;
  };
}

export const MOL_LIB_TOKEN = 'MOL_LIB_TOKEN';
